import { Hero } from '@/components/sections/Hero';
import { SelectedWork } from '@/components/sections/SelectedWork';
import { SkillsShowcase } from '@/components/sections/SkillsShowcase';
import type { Bootstrap } from '@/lib/types';

export function HomePage({ data }: { data: Bootstrap }) {
  return (
    <>
      <Hero
        profile={data.profile}
        socialLinks={data.socialLinks}
        projects={data.projects}
        technologyCount={data.skills.reduce((sum, group) => sum + group.items.length, 0)}
      />
      <SelectedWork projects={data.projects} />

      <div className="shell">
        <div className="rule" />
      </div>

      <SkillsShowcase skills={data.skills} />
    </>
  );
}
